import React from 'react';

import { DEFAULT_TIMEZONE, TIMEZONE_STRINGS } from 'constants/Misc';

function TimezoneSelector({ disabled = false, forceValue = null, label = null }) {
  const timezone = localStorage.getItem('client_timezone');

  const handleChange = ({ target }) => {
    if (disabled) return;
    localStorage.setItem('client_timezone', JSON.stringify(target.value));
    window.location.reload();
  };

  if (!timezone && !disabled) {
    localStorage.setItem('client_timezone', JSON.stringify(DEFAULT_TIMEZONE));
  }

  const currentValue = forceValue ?? (timezone ? JSON.parse(timezone) : DEFAULT_TIMEZONE);

  return (
    <div className="d-flex align-items-center">
      {label && <span className="timezone-warning">{label}</span>}
      <select
        className="timezone-selector"
        onChange={handleChange}
        value={currentValue}
        disabled={disabled}
        style={disabled ? { cursor: 'not-allowed', opacity: 0.7 } : {}}
      >
        {TIMEZONE_STRINGS.map(({ label, value }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default TimezoneSelector;
